const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/',
  LANDING: '/landing',
  STUDENT: '/student',
  PROFILEREVIEW: '/profile-review',
  ENROLLMENT: '/enrollment',
  ASSESSMENTS: '/assessments',
  VEHICLE: '/vehicle',
  PART: '/part',
  WORKORDER: '/workorder',
  PURCHASE_ORDER: '/purchase-order',
  CROSS_BOUNDARY: '/crossboundary-request',
  ROUTING: '/routing-request',
  SCHOOL_YEAR: '/school-year',
  FILE_EXPORT: '/file-export',
  STUDENT_CAREERS: '/careers',
  SCREEN_SHARE: '/screenshare',
};

// ----------------------------------------------------------------------

export const paths = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  // DASHBOARD
  dashboard: ROOTS.DASHBOARD,
  // LANDING
  landing: ROOTS.LANDING,
  // STUDENT
  student: {
    root: ROOTS.STUDENT,
    profile: (asn) => `${ROOTS.STUDENT}/${asn}`,
    career: (asn) => `${ROOTS.STUDENT}/${asn}/?tab=career`,
  },
  // PROFILE REVIEW
  profileReview: {
    root: ROOTS.PROFILEREVIEW,
    edit: (profileReviewId) => `${ROOTS.PROFILEREVIEW}/${profileReviewId}`,
    start: (profileReviewId) => `${ROOTS.PROFILEREVIEW}/${profileReviewId}/start`,
    form: (profileReviewId) => `${ROOTS.PROFILEREVIEW}/${profileReviewId}/form`,
    confirmation: (profileReviewId) => `${ROOTS.PROFILEREVIEW}/${profileReviewId}/confirmation`,
  },
  enrollment: {
    root: ROOTS.ENROLLMENT,
    edit: (enrollmentId) => `${ROOTS.ENROLLMENT}/${enrollmentId}`,
  },
  assessments: {
    root: ROOTS.ASSESSMENTS,
    wrat5: `${ROOTS.ASSESSMENTS}/wrat5`,
    lens: `${ROOTS.ASSESSMENTS}/lens`,
    adlof: `${ROOTS.ASSESSMENTS}/adlof`,
    new: `${ROOTS.ASSESSMENTS}/new`,
    details: (type, assessmentId) => `${ROOTS.ASSESSMENTS}/${type}/${assessmentId}`,
  },
  crossboundary: {
    root: ROOTS.CROSS_BOUNDARY,
  },
  routing: {
    root: ROOTS.ROUTING,
  },
  schoolYear: {
    root: ROOTS.SCHOOL_YEAR,
  },
  fileExport: {
    root: ROOTS.FILE_EXPORT,
  },

  // VEHICLE
  vehicle: {
    root: ROOTS.VEHICLE,
    new: `${ROOTS.VEHICLE}/new`,
    edit: (vehicleId) => `${ROOTS.VEHICLE}/${vehicleId}/edit`,
    details: (vehicleId) => `${ROOTS.VEHICLE}/${vehicleId}`,
  },
  // PART
  part: {
    root: ROOTS.PART,
    new: `${ROOTS.PART}/new`,
    edit: (partId) => `${ROOTS.PART}/${partId}/edit`,
  },
  // WORK ORDER
  workOrder: {
    root: ROOTS.WORKORDER,
    new: `${ROOTS.WORKORDER}/new`,
    edit: (workOrderId) => `${ROOTS.WORKORDER}/${workOrderId}/edit`,
  },
  // PURCHASE ORDER
  purchaseOrder: {
    root: ROOTS.PURCHASE_ORDER,
    new: `${ROOTS.PURCHASE_ORDER}/new`,
    edit: (purchaseOrderId) => `${ROOTS.PURCHASE_ORDER}/${purchaseOrderId}/edit`,
  },

  // STUDENT CAREERS
  careers: {
    root: ROOTS.STUDENT_CAREERS,
    profiles: `${ROOTS.STUDENT_CAREERS}/profiles`,
    profile: (profileId) => `${ROOTS.STUDENT_CAREERS}/profiles/${profileId}`,
    businesses: `${ROOTS.STUDENT_CAREERS}/businesses`,
  },
  // SCREEN SHARE
  screenShare: {
    root: ROOTS.SCREEN_SHARE,
    share: `${ROOTS.SCREEN_SHARE}/share`,
    join: `${ROOTS.SCREEN_SHARE}/view`,
  },
};
